import { useState } from "react"
import BlueTableHeading from "../../../common/AdminCommonComponents/BlueTableHeading/BlueTableHeading"
import ActionButton from "../../../common/AdminCommonComponents/Buttons/ActionButton/ActionButton"
import DynamicDatatable from "../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable"
import DynamicTableFilters from "../../../common/AdminCommonComponents/DynamicTableFilters/DynamicTableFilters"
import LightGrayBgWrapper from "../../../common/AdminCommonComponents/LightGrayBgWrapper/LightGrayBgWrapper"
import PayoutDetails from "./PayoutDetails/PayoutDetails"
import StatusBadge from "../../../common/AdminCommonComponents/StatusBadge/StatusBadge"

const Payouts = () => {
  const [viewDetails, setViewDetails] = useState(false)

  const actions = [
    { label: "View Details", action: () => setViewDetails(true) },
    { label: "Edit", action: () => {} },
    { label: "Delete", action: () => {} },
    { label: "Change Status", action: () => {} },
  ]

  const data = [
    { payoutStatus: "Pending", sellers: "10", partners: "5", total: "120" },
    { payoutStatus: "Processed", sellers: "150", partners: "5", total: "120" },
    { payoutStatus: "Failed", sellers: "2", partners: "5", total: "120" },
  ]

  const columns = [
    {
      name: "Payout Status",
      selector: (row) => row.payoutStatus,
    },
    {
      name: "Sellers",
      selector: (row) => row.sellers,
    },
    {
      name: "Partners",
      selector: (row) => row.partners,
    },
    {
      name: "Total",
      selector: (row) => row.total,
    },
  ]

  const payoutsData = [
    {
      sr: 1,
      payoutID: "001",
      date: "2024-11-20",
      recipientType: "Purchase",
      recepientName: "John Doe",
      amount: "$450",
      status: "In Transit",
      paymentMethod: "Bank Transfer",
      scheduledDate: "2024-11-20",
    },
    {
      sr: 2,
      payoutID: "001",
      date: "2024-11-20",
      recipientType: "Purchase",
      recepientName: "John Doe",
      amount: "$450",
      status: "Paid",
      paymentMethod: "Bank Transfer",
      scheduledDate: "2024-11-20",
    },
    {
      sr: 3,
      payoutID: "001",
      date: "2024-11-20",
      recipientType: "Purchase",
      recepientName: "John Doe",
      amount: "$450",
      status: "In Transit",
      paymentMethod: "Bank Transfer",
      scheduledDate: "2024-11-20",
    },
    {
      sr: 4,
      payoutID: "001",
      date: "2024-11-20",
      recipientType: "Purchase",
      recepientName: "John Doe",
      amount: "$450",
      status: "In Transit",
      paymentMethod: "Bank Transfer",
      scheduledDate: "2024-11-20",
    },
  ]

  const payoutsCols = [
    {
      name: "Sr.",
      selector: (row) => row.sr,
      sortable: true,
      grow: 0.3
    },
    {
      name: "Payout ID",
      selector: (row) => row.payoutID,
      sortable: true,
    },
    {
      name: "Date",
      selector: (row) => row.date,
      sortable: true,
    },
    {
      name: "Recipient Type",
      selector: (row) => row.recipientType,
      sortable: true,
    },
    {
      name: "Recipient Name",
      selector: (row) => row.recepientName,
      sortable: true,
    },
    {
      name: "Amount",
      selector: (row) => row.amount,
      sortable: true,
      right: true,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      center: true,
      cell: (row) => (
        <StatusBadge statusName={row.status} />
      ),
    },
    {
      name: "Payment Method",
      selector: (row) => row.paymentMethod,
      sortable: true,
    },
    {
      name: "Scheduled Date",
      selector: (row) => row.scheduledDate,
      sortable: true,
    },
    {
      name: "Action",
      cell: () => <ActionButton options={actions} />,
      center: "true",
    },
  ]
  

  return (
    <LightGrayBgWrapper>
      <div className="rounded shadow">
        <DynamicDatatable data={data} columns={columns} type="yellow" />
      </div>

      {viewDetails ? (
        <PayoutDetails onClick={setViewDetails} />
      ) : (
        <div className="bg-white shadow mt-3">
          <BlueTableHeading className="px-4 py-3 fw-semibold fs-5">Payouts</BlueTableHeading>

          <DynamicTableFilters componentName="Pricing Finance & Payment Payouts" />

          <div className="p-3">
            <DynamicDatatable data={payoutsData} columns={payoutsCols} type="gray" pagination />
          </div>
        </div>
      )}
    </LightGrayBgWrapper>
  )
}

export default Payouts
